import { oneOfType, string } from 'prop-types';

import messageDescriptor from '../../lingui/LinguiPropTypes';
import { usePageId } from '../page/PageUtils';
import Actions from '../actions/Actions';
import PanBackAction from '../actions/PanBackAction';
import PanForwardAction from '../actions/PanForwardAction';
import ResetAction from '../actions/ResetAction';
import ZoomInAction from '../actions/ZoomInAction';
import ZoomOutAction from '../actions/ZoomOutAction';
import ReportAction, { reportActionOptionsType } from '../actions/ReportAction';

export default function PageActions({ pageTitle, showTimeRangeControls, reportActionOptions }) {
    const pageId = usePageId();

    return (
        <Actions>
            {showTimeRangeControls !== false && (
                <>
                    <PanBackAction tooltipPlacement="bottom" />
                    <PanForwardAction tooltipPlacement="bottom" />
                    <ZoomInAction tooltipPlacement="bottom" />
                    <ZoomOutAction tooltipPlacement="bottom" />
                    <ResetAction tooltipPlacement="bottom" />
                </>
            )}
            <ReportAction
                pageId={pageId}
                pageTitle={pageTitle}
                options={reportActionOptions}
                tooltipPlacement="bottom"
            />
        </Actions>
    );
}

PageActions.propTypes = {
    pageTitle: oneOfType([messageDescriptor, string]),
    reportActionOptions: reportActionOptionsType,
};

PageActions.defaultProps = {
    pageTitle: undefined,
    reportActionOptions: undefined,
};
